import Vue from 'vue';
import axios from 'axios';

const instance = axios.create({
  baseURL: process.env.API_LOCATION,
  headers: {
    Accept: '*/*',
  },
  withCredentials: false,
});

Vue.prototype.$http = Vue.$http = instance;




// WEBPACK FOOTER //
// ./src/plugins/axios.js